import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { PrivaStatusCircleModule } from '@priva/components/status-circle';
import { PrivaTableColumnDirective, PrivaTableComponent } from '@priva/components/table';
import { PrivaLocalizationModule } from '@priva/localization';
import { PrivaStatus } from '@priva/styles/foundation';

import { Registration, RegistrationType } from 'app/features/manual-input-registration/models';
import { selectCachedRegistrationsAsArray } from 'app/state/registrations/registrations.selectors';

import { RowRegistrationStatus } from '../../features/map-row-selector/models';

@Component({
    selector: 'app-registrations-table',
    templateUrl: './registrations-table.component.html',
    styleUrl: './registrations-table.component.scss',
    imports: [
        AsyncPipe,
        DatePipe,
        PrivaLocalizationModule,
        PrivaStatusCircleModule,
        PrivaTableComponent,
        PrivaTableColumnDirective,
    ],
})
export class RegistrationsTableComponent {
    private store = inject(Store);

    RegistrationType = RegistrationType;

    readonly cachedRegistrations$ = this.store.select(selectCachedRegistrationsAsArray);

    asRegistration = (row: unknown): Registration => row as Registration;

    getLocationStatus(status: RowRegistrationStatus): PrivaStatus {
        return status === 'done' ? 'Success' : 'Warning';
    }
}
